import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { View } from 'react-native';
import { WHITE } from '../../constants';
import { useBreakpoint } from '../../hooks';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { GradientView } from '../gradient-view';
import { Typography } from '../typography';
import { constants } from './HighlightConstants';
import { getHighlightProps, getHighlightStyles } from './HighlightStyles';
import { Offer } from './components/offer';
import { SocialProof } from './components/social-proof';
export var Highlight = props => {
  var stateContext = useContext(StateConfigContext);
  var highlightProps = getHighlightProps(props, stateContext);
  var highlightStyles = getHighlightStyles(highlightProps);
  var _highlightProps$testI = highlightProps.testID,
    testID = _highlightProps$testI === void 0 ? 'Highlight' : _highlightProps$testI,
    text = highlightProps.text,
    boldText = highlightProps.boldText,
    _highlightProps$type = highlightProps.type,
    type = _highlightProps$type === void 0 ? constants.OFFER : _highlightProps$type,
    _highlightProps$iconT = highlightProps.iconType,
    iconType = _highlightProps$iconT === void 0 ? type : _highlightProps$iconT,
    _highlightProps$varia = highlightProps.variant,
    variant = _highlightProps$varia === void 0 ? constants.UNDER_CARD : _highlightProps$varia,
    iconName = highlightProps.iconName,
    _highlightProps$multi = highlightProps.multiText,
    multiText = _highlightProps$multi === void 0 ? [] : _highlightProps$multi,
    _highlightProps$iconP = highlightProps.iconProps,
    iconProps = _highlightProps$iconP === void 0 ? {} : _highlightProps$iconP,
    _highlightProps$logoG = highlightProps.logoGroupProps,
    logoGroupProps = _highlightProps$logoG === void 0 ? [] : _highlightProps$logoG,
    innerContainerStyle = highlightProps.innerContainerStyle,
    style = highlightProps.style;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true,
      allowMdAsLargeScreen: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var GradientViewChildren = _jsxs(GradientView, Object.assign({
    type: type === constants.SOCIAL_PROOF ? constants.STELLAR : constants.MANTLE,
    style: [highlightStyles.innerContainer, innerContainerStyle]
  }, getTestId(testID, variant + "_children"), {
    children: [iconType !== constants.LOGO_GROUP && _jsxs(View, Object.assign({
      style: highlightStyles.iconContainer
    }, {
      children: [iconType === constants.OFFER && _jsx(Offer, {}), iconType === constants.SOCIAL_PROOF && _jsx(SocialProof, {}), !!iconName && _jsx(DynamicSvg, Object.assign({
        iconName: iconName,
        fontSize: 16,
        color: WHITE,
        style: iconType !== constants.LOGO && highlightStyles.offerIcon
      }, iconProps, getTestId(testID, 'icon')))]
    })), iconType === constants.LOGO_GROUP && (logoGroupProps === null || logoGroupProps === void 0 ? void 0 : logoGroupProps.length) > 1 && (logoGroupProps === null || logoGroupProps === void 0 ? void 0 : logoGroupProps.length) < 5 && _jsx(View, Object.assign({
      style: highlightStyles.logoGroupContainer
    }, getTestId(testID, 'groupLogo'), {
      children: logoGroupProps === null || logoGroupProps === void 0 ? void 0 : logoGroupProps.map((logo, index) => _jsx(DynamicSvg, Object.assign({
        iconName: logo === null || logo === void 0 ? void 0 : logo.iconName,
        style: index != 0 && highlightStyles.logoGroupIconStyle,
        fontSize: 28
      }, logo.iconProps), "logo-" + index))
    })), _jsx(View, Object.assign({
      style: highlightStyles.text
    }, {
      children: _jsx(Typography, Object.assign({
        multiText: [{
          text: text,
          type: "body-para-" + (isLargeScreen ? 'sm' : 'xs')
        }, Object.assign({}, boldText && {
          text: ' ' + boldText,
          type: "body-para-" + (isLargeScreen ? 'sm' : 'xs') + "-bold"
        }), ...multiText],
        numberOfLines: 1,
        type: "body-para-sm"
      }, getTestId(testID, 'text')))
    }))]
  }));
  return (!!text || !!boldText || !!(multiText === null || multiText === void 0 ? void 0 : multiText.length)) && (variant === constants.IN_CARD ? _jsx(GradientView, Object.assign({}, getTestId(testID), {
    style: [highlightStyles.container, style],
    type: type === constants.SOCIAL_PROOF ? constants.DODGER_BLUE : constants.RETRO
  }, {
    children: GradientViewChildren
  })) : (variant === constants.UNDER_CARD || variant === constants.ON_CARD) && GradientViewChildren);
};